import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { LoadModalWithLabel } from "../modais"
import {
  Loading,
  InputCustom,

  SelectCustom,
  HttpError
} from "../../components"
import * as ApiHelper from "../../ApiHelper"
import { ToastContainer, ToastMessage } from "react-toastr"
import $ from "jquery"
import ItemNotaModal from "./ItemNotaModal"
import Util from "../../Util"
import InputDinheiroBR from "../../components/InputDinheiroBR"
class NotaForm extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.onChangeData = this.onChangeData.bind(this)
    this.onChangeNumero = this.onChangeNumero.bind(this)
    this.getNotaEdit = this.getNotaEdit.bind(this)
    this.fillFields = this.fillFields.bind(this)
    this.getItemDeContratoValue = this.getItemDeContratoValue.bind(this)
    this.removeCurrentItem = this.removeCurrentItem.bind(this)
    this.toggleItensModal = this.toggleItensModal.bind(this)
    this.addItem = this.addItem.bind(this)
    this.removeItem = this.removeItem.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.addAlert = this.addAlert.bind(this)
    this.reloadItem = this.reloadItem.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      numeroLabel: "",
      numero: "",
      data: "",
      valor: "",
      currentItens: [],
      itens: [],
      itensError: [],
      contrato: {},
      showForm: false,
      itensDeContrato: [],
      showItemModal: false
    }
    this.showSucessMessage = this.showSucessMessage.bind(this)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  showSucessMessage() {
    var message = "Nota atualizada com sucesso"
    var title = "Sucesso"
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000
    })
  }
  showErrorMessage() {
    this.container.error(
      "Ocorreram erros",
      "Verifique os dados e tente novamente",
      {
        timeOut: 2000,
        extendedTimeOut: 3000
      }
    )
  }

  componentWillMount() {
    this.getNotaEdit()
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  componentDidUpdate(prevProps, prevState) {
    //Pequeno ajuste tecnico devido bug no datepicker
    $(".is-empty").removeClass("is-empty")
  }
  getNotaEdit() {
    var notaId = this.props.match.params.id
    ApiHelper.getNotaEdit(notaId, (nota, error) => {
      if (nota) {
        this.fillFields(nota)
        window.scrollTo(0, 0)
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  fillFields(fields) {
    this.setState({
      numero: fields.numero,
      numeroLabel: fields.numero,
      data: fields.data,
      currentItens: fields.itens_nota,
      valor: fields.valor,
      itensDeContrato: Util.mapItensDeContrato(
        fields.contrato.itens_de_contratos
      ),
      contrato: fields.contrato,
      showForm: true
    })
  }
  onChangeData(value) {
    this.setState({
      data: Util.dateOnly(value)
    })
  }
  onChangeNumero(event) {
    var newValue = event.target.value
    this.setState({
      numero: newValue
    })
  }
  getItemDeContratoValue(id) {
    var itemValue = 0
    this.state.itensDeContrato.forEach(item => {
      if (item.value === parseInt(id, 10)) {
        itemValue = item.valor
      }
    })
    return itemValue
  }
  toggleItensModal(event, index, id) {
    this.setState({
      editingItemID: id,
      showItemModal: !this.state.showItemModal
    })
  }
  removeCurrentItem(event, index, id) {
    event.preventDefault()
    ApiHelper.deleteItemNota(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        var oldCurrentItens = this.state.currentItens
        var item = oldCurrentItens[index]
        var valor =
          item.quantidade *
          this.getItemDeContratoValue(item.itens_de_contrato_id)
        oldCurrentItens.splice(index, 1)
        this.setState({
          valor: this.state.valor - valor,
          currentItens: oldCurrentItens
        })
      }
    })
  }
  removeItem(index) {
    var oldItens = this.state.itens
    var oldErrors = this.state.itensError
    oldItens.splice(index, 1)
    oldErrors.splice(index, 1)
    this.setState({
      itens: oldItens
    })
  }
  addItem() {
    var oldItens = this.state.itens
    var oldErrors = this.state.itensError
    oldItens.push({
      quantidade: "",
      itemDeContrato: "",
      observacao: "",
      valor: ""
    })
    oldErrors.push({
      quantidade: "",
      itens_de_contrato_id: "",
      observacao: ""
    })
    this.setState({
      itens: oldItens
    })
  }
  onChangeItemDeContrato(event, index) {
    var newValue = event.target.value
    var oldItens = this.state.itens
    oldItens[index].itemDeContrato = newValue
    var valor = 0
    var quantidade = 0
    var isBaixaValorChecked = oldItens[index].baixaValor
    var valorUnitario = this.getItemDeContratoValue(newValue || 0)
    if (isBaixaValorChecked) {
      valor = oldItens[index].valor
      quantidade = valor / valorUnitario
    } else {
      quantidade = oldItens[index].quantidade
      valor = quantidade * valorUnitario
    }
    oldItens[index].quantidade = quantidade
    oldItens[index].valor = valor
    oldItens[index].valorUnitario = valorUnitario
    this.setState({
      itens: oldItens
    })
  }
  onChangeObservacaoNota(event, index) {
    var newValue = event.target.value
    var oldItens = this.state.itens
    oldItens[index].observacao = newValue
    this.setState({
      itens: oldItens
    })
  }
  onChangeBaixaValor(event, index) {
    var newValue = event.target.checked
    var oldItens = this.state.itens
    oldItens[index].baixaValor = newValue
    this.setState({
      itens: oldItens
    })
  }
  onChangeQuantidadeNota(event, index, value) {
    var oldItens = this.state.itens
    var isBaixaValorChecked = oldItens[index].baixaValor
    var newValue = 0
    var valor = 0
    var valorUnitario = this.getItemDeContratoValue(
      oldItens[index].itemDeContrato || 0
    )
    if (isBaixaValorChecked) {
      valor = value
      newValue = valor / valorUnitario
    } else {
      newValue = event.target.value
      valor = newValue * valorUnitario
    }
    oldItens[index].quantidade = newValue
    oldItens[index].valor = valor
    this.setState({
      itens: oldItens
    })
  }
  reloadItem(value) {
    var oldCurrentItens = this.state.currentItens
    oldCurrentItens.forEach((item, index) => {
      if (item.id === value.id) {
        oldCurrentItens[index] = value
      }
    })
    this.setState({
      currentItens: oldCurrentItens,
      showItemModal: !this.state.showItemModal
    })
  }
  sendForm(event) {
    event.preventDefault()
    var notaId = this.props.match.params.id
    var valorNota = this.state.valor
    var itens = []
    this.state.itens.forEach(item => {
      valorNota += item.valor
      itens.push({
        quantidade: item.quantidade,
        observacao: item.observacao,
        itens_de_contrato_id: item.itemDeContrato,
        valor_unitario: item.valorUnitario
      })
    })
    var params = {
      numero: this.state.numero,
      data: this.state.data,
      contrato_id: this.state.contrato.id,
      valor: valorNota,
      itens: itens.length === 0 ? undefined : itens
    }
    this.toggleLoadModal()
    ApiHelper.updateNota(notaId, params, error => {
      this.toggleLoadModal()
      if (error) {
        this.showErrorMessage()
        this.handleErrors(error)
      } else {
        this.showSucessMessage()
        Util.sleep(3000).then(() => {
          this.props.notaCallBack()
        })
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.erros
    var errorsState = {}
    var itensError = this.state.itensError
    for (var key in errorsValue) {
      if (key.includes("itens.")) {
        var index = key.split("itens.").join("")
        if (index.includes(".quantidade")) {
          index = index.split(".quantidade").join("")
          itensError[index].quantidade = errorsValue[key][0]
        }
        if (index.includes(".itens_de_contrato_id")) {
          index = index.split(".itens_de_contrato_id").join("")
          itensError[index].itens_de_contrato_id = errorsValue[key][0]
        }
        if (index.includes(".observacao")) {
          index = index.split(".observacao").join("")
          itensError[index].observacao = errorsValue[key][0]
        }
      } else {
        errorsState[key + "Error"] = errorsValue[key][0]
      }
    }
    errorsState.itensError = itensError
    this.setState(errorsState)
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return this.state.showForm ? (
      <div className="container-fluid">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <div className="card card-plain">
          <div className="card-header" data-background-color="as-blue">
            <ItemNotaModal
              itemID={this.state.editingItemID}
              callBack={this.reloadItem}
              show={this.state.showItemModal}
              onClose={this.toggleItensModal}
            />
            <ToastContainer
              ref={input => {
                this.container = input
              }}
              toastMessageFactory={this.toastFactory}
              className="toast-top-right"
              preventDuplicates={true}
            />
            <h4 className="title">Editar nota fiscal</h4>
            <p className="category">Número da nota: {this.state.numeroLabel}</p>
          </div>
          <div className="card card-content">
            <div className="row">
              <InputCustom
                error={this.state.numeroError}
                onChange={this.onChangeNumero}
                type="number"
                sizeClass="col-md-2"
                label={"Número da nota fiscal"}
                value={this.state.numero}
              />
            </div>
            <div className="row">
              <InputCustom
                error={this.state.dataError}
                placeholder=" "
                onChange={this.onChangeData}
                type="date"
                sizeClass="col-md-2"
                label={"Data da nota fiscal"}
                value={this.state.data}
              />
            </div>
            <div className="card">
              <div className="card-header" data-background-color="as-blue">
                <h4 className="title">Itens da nota fiscal</h4>
                <p className="category">Itens que descrevem o valor da nota</p>
              </div>
              <div className="card-content">
                {this.state.currentItens.map((item, key) => {
                  return (
                    <div key={key} className="card card-content">
                      <div className="row">
                        <SelectCustom
                          disabled={true}
                          sizeClass="col-md-7"
                          label="Item de contrato"
                          options={this.state.itensDeContrato}
                          value={item.itens_de_contrato_id}
                        />
                      </div>
                      <div className="row">
                        <InputCustom
                          disabled={true}
                          type="text"
                          sizeClass="col-md-7"
                          label="Observação"
                          value={item.observacao}
                        />
                      </div>
                      <div className="row">
                        <InputCustom
                          disabled={true}
                          type="number"
                          sizeClass="col-md-7"
                          label="Quantidade"
                          value={parseFloat(item.quantidade).toFixed(2)}
                        />
                      </div>
                      <div className="row">
                        <InputCustom
                          disabled={true}
                          type="number"
                          sizeClass="col-md-7"
                          label={"Observacão"}
                          value={item.observacao}
                        />
                      </div>
                      <div className="row">
                        <button
                          title="Remover item"
                          onClick={event =>
                            this.removeCurrentItem(event, key, item.id)
                          }
                          className="btn btn-danger pull-right"
                          data-background-color="red"
                        >
                          <i className="icon-header material-icons">delete</i>
                        </button>
                        <button
                          title="Editar item"
                          onClick={event =>
                            this.toggleItensModal(event, key, item.id)
                          }
                          className="btn btn-danger pull-right"
                          data-background-color="blue"
                        >
                          <i className="icon-header material-icons">create</i>
                        </button>
                      </div>
                      <span className="label label-rose">
                        Valor do item:{" "}
                        {Util.formatCurrency(
                          item.quantidade * item.valor_unitario
                        )}
                      </span>
                    </div>
                  )
                })}
                {this.state.itens.map((item, key) => {
                  return (
                    <div className="card card-content">
                      <div key={key} className="row">
                        <SelectCustom
                          error={
                            this.state.itensError[key].itens_de_contrato_id
                          }
                          onChange={event =>
                            this.onChangeItemDeContrato(event, key)
                          }
                          options={this.state.itensDeContrato}
                          sizeClass="col-md-12"
                          label="Item de contrato"
                          value={item.itemDeContrato}
                        />
                        <InputCustom
                          type="checkbox"
                          sizeClass="col-md-1"
                          checked={item.baixaValor}
                          label="Valor"
                          onChange={event =>
                            this.onChangeBaixaValor(event, key)
                          }
                        />
                        {this.state.itens[key].baixaValor ? (
                          <InputDinheiroBR
                            error={this.state.itensError[key].quantidade}
                            onChange={(valueFormatado, value) =>
                              this.onChangeQuantidadeNota({target:{value:value}}, key, value)
                            }
                            sizeClass="col-md-2"
                            label="Valor"
                            value={item.valor}
                          />
                        ) : (
                          <InputCustom
                            error={this.state.itensError[key].quantidade}
                            step="0.01"
                            onChange={event =>
                              this.onChangeQuantidadeNota(event, key, undefined)
                            }
                            type="number"
                            sizeClass="col-md-2"
                            label="Quantidade"
                            value={item.quantidade}
                          />
                        )}
                        <InputCustom
                          error={this.state.itensError[key].observacao}
                          onChange={event =>
                            this.onChangeObservacaoNota(event, key)
                          }
                          type="text"
                          sizeClass="col-md-9"
                          label="Observação"
                          value={item.observacao}
                        />
                      </div>
                      <div className="row text-center">
                        <span className="label label-rose label-large">
                          Valor total do item:{Util.formatCurrency(item.valor)}
                        </span>
                        <button
                          onClick={() => this.removeItem(key)}
                          className="btn btn-danger pull-right"
                          data-background-color="red"
                        >
                          <i className="icon-header material-icons">delete</i>
                        </button>
                      </div>
                    </div>
                  )
                })}

                <button
                  onClick={this.addItem}
                  className="btn btn-primary pull-right"
                  data-background-color="green"
                >
                  <i className="icon-header material-icons">add</i>
                </button>
              </div>
            </div>
            <button
              onClick={this.sendForm}
              type="submit"
              className="btn btn-primary pull-left"
              data-background-color="as-blue"
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    ) : (
      <Loading />
    )
  }
}
export default withRouter(NotaForm)



// WEBPACK FOOTER //
// ./src/views/modais/NotaForm.js